let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Fkef4")).then(() => parcelRequire('5pz6a'));